module.exports = __webpack_public_path__ + "static/media/contantedit.2c500ad9.svg";